// import React, { useState, useEffect } from "react";
import React from "react";
import portfolio from "../assets/portfolio/Portfolio.json";

const Portfolio = () => {
  //  const getPortfolio = async () => {
  //    let url = "https://portfolio-json.netlify.app/portfolio.json";
  //    let data = await fetch(url);
  //    let parsedData = await data.json();
  //    setPortfolio(parsedData);
  //  };
  // useEffect(() => {
  //   getPortfolio();
  //    // eslint-disable-next-line react-hooks/exhaustive-deps
  //  }, []);

  return (
    <div name="portfolio">
      <div className="text-white p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className=" pb-8">
          <p className=" text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Check out my work</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolio.map(({ id, src, href, code }) => {
            return (
              <div
                key={id}
                className="shadow-md shadow-gray-600 rounded-lg overflow-hidden duration-200"
              >
                <img
                  src={src}
                  alt=""
                  className="rounded-md duration-200 hover:scale-105 hover:rounded-md"
                />
                <div className="flex items-center justify-center">
                  <a
                    href={href}
                    className=" w-1/2 px-6 py-3 m-4 duration-400 hover:bg-slate-800 mr-3 text-center rounded-lg"
                  >
                    Live
                  </a>
                  <a
                    href={code}
                    className=" w-1/2 px-6 py-3 m-4 duration-400 hover:bg-slate-800 ml-3 text-center rounded-lg"
                  >
                    Code
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
